import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '../../environments/environment';

import { Publicacion } from '../models/publicacion';
import { PublicacionService } from '../services/publicacion.service';

// declare var $: any;

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.css']
})
export class NoticiasComponent implements OnInit {

  models: Publicacion[];
  filtro: FormGroup;
  tipos;
  secciones;
  years;
  url = environment.imgUrl;
  p;
  constructor(private modelService: PublicacionService, private formBuilder: FormBuilder) {
    this.models = [];

  }

  ngOnInit() {
    // $("#yearPicker").datetimepicker({
    //   format: "YYYY", // Notice the Extra space at the beginning
    //   viewMode: "years",
    //   //minViewMode: "years",
    //   //orientation: "bottom auto"
    // });


    // let self = this;
    // $("#datepicker").datetimepicker()
    //   .on('changeYear', function(e) {
    //     self.onSubmit();
    //   });

    // $('#yearPicker').datetimepicker()
    //   .on("dp.update", function() {
    //     console.log('eee')
    //   })
    //

    this.modelService.getTipo().subscribe(val => this.tipos = val);

    this.modelService.getSeccion().subscribe(val => this.secciones = val);

    this.modelService.getYears().subscribe(val => this.years = val);


    this.filtro = this.formBuilder.group({
      tipo: [0],
      seccion: [0],
      year: [0]
    });

    this.onSubmit();
  }

  onSubmit() {

    if (this.filtro.value.seccion != 1) {
      this.filtro.value.tipo = 0;
    }

    this.modelService.getFilter(this.filtro.value).subscribe(val => {
      this.models = val;

    });
  }

}
